/**
 *    @author:
 *    @since:
 *
 */

import { Component, HostListener, OnInit, ViewChild} from '@angular/core';
import { Router } from '@angular/router'; 
import { TimerService } from 'src/refresh/service/timer-service';
import { FormBaseComponent } from '../_common/component/form-base.component';
import { Address, BaseAddress, Eligibility, InputData, ParentInfo } from '../_common/data/input-data';
import { Path, Progress } from  "../_common/constant/page-const";
import { FinalReviewValidation } from './final_review.validator';
import { ItemList } from '../_common/constant/item-list';
import { BirthPlace, Code, Confirm, Country } from 'src/refresh/service/constant';
import { TranslateService } from '@ngx-translate/core';
import { Util } from 'src/refresh/service/Util';
import { LightBox } from 'src/refresh/layout/light-box/light-box.component';
import { ViewportScroller } from '@angular/common';
import { ProgressService } from 'src/refresh/service/progress-service';
import { CommonService } from 'src/refresh/service/common-service';

@Component({ 
      selector: 'final_review',
      templateUrl: './final_review.component.html',
      styleUrls: ['./final_review.component.less']
})
export class FinalReviewComponent extends FormBaseComponent implements OnInit {

      aboutChild:any;
      childNameParam: Object;
      parentNameParam: Object;
      lastOrSingleNameParam: Object;
      certifieParam: Object;
      childName: string = "";
      childWeight: string = "";
      childBirthOrder: string ="";
      ///childCityTown : string = "";
      placeOfBirth : string = "";
      nameOfBPlace : string = "";
      attendantType: string = "";
      attendantName: string = "";
      phoneNumber: string = "";
      daytimePhoneNumber: string = "";
      birthParent: ParentInfo;
      nonBirthParents: ParentInfo[];
      parentCertifyName: string;
      openStatementParam: string;
      childLastName: string;
      orgContactPath = Path.ORGContactInformation;
      isOpened:boolean = false;
      isOnEditOpened:boolean = false;
      consentContent: string;

      eligibility: Eligibility;
      error_invalidBirthCertify : string;
      error_invalidLastNameCertify: string;
      error_notice: string;

      @ViewChild('editLightBox', { static: true }) 
      editLightBox: LightBox;

      @ViewChild('noticeOfCollectionBox', { static: true }) 
      noticeOfCollectionBox: LightBox;
     

      constructor( protected router: Router,
                   public timerService:TimerService,
                   public data:InputData,
                   private items:ItemList,
                   protected progress:ProgressService,
                   public translateService: TranslateService,
                   public viewportScroller: ViewportScroller,
                   private commonService: CommonService ) {

            super(router,timerService,progress);  
            
            this.eligibility = this.data.eligibility;
            this.aboutChild = this.data.aboutChild;

            super.setValidator(new FinalReviewValidation(this,Progress.Review));

            this.childName = this.aboutChild.name.getFullName();
            this.childLastName = this.data.aboutChild.name.getSingleOrLast();
            this.childNameParam = { childName:  this.childName };
           
            this.birthParent = this.data.parents.find((p) => 
                 p.isGiveBirth == 'Y'
            );

            this.nonBirthParents = this.data.parents.filter((p) => 
                  p.isGiveBirth != 'Y'
            );

            if(this.data.eligibility.isCustodyOtherThanParent == 'Y'){
                  this.openStatementParam = this.translateService.instant('final_review.open_statement.i') ;
                  this.consentContent = this.translateService.instant('final_review.birth_registration.content1_i');
            }else{
                  this.openStatementParam = this.data.eligibility.certifyingParentCount > 1 ? this.translateService.instant('final_review.open_statement.we_parent') : 
                        this.translateService.instant('final_review.open_statement.i_parent');

                  this.consentContent = this.data.eligibility.certifyingParentCount > 1 ? this.translateService.instant('final_review.birth_registration.content1_we') : 
                        this.translateService.instant('final_review.birth_registration.content1_i');     
            }

            if(data.aboutChild.isParentAgreeOnSingleName == Confirm.YES){
                  this.lastOrSingleNameParam = this.translateService.instant('final_review.singleName');
            }else if(data.aboutChild.isParentAgreeOnLastName == Confirm.YES){
                  this.lastOrSingleNameParam = this.translateService.instant('final_review.lastName');
            }

            this.certifieParam = this.data.eligibility.certifyingParentCount > 1 ? 'certifions' : 'certifie';

            this.phoneNumberDisplay();
            this.daytimePhoneDisplay();
            this.getParentNames();
            this.getWeight();  
            this.getBirthOrder();
            this.getPlace();
            this.getAttendant();

            if ( this.eligibility.isCustodyOtherThanParent == Confirm.YES &&
                 this.aboutChild.isChildDeceased == Confirm.YES ) 
                 super.setNextPage(Path.OrderSummary,Path.ContactInfoAndMailingAddress);
            else 
                 super.setNextPage(Path.Transition1,Path.ContactInfoAndMailingAddress);

            this.commonService.getCloseLightBox().subscribe((r) =>{
                  if(this.isOpened) this.onNoticeClose();
                  if(this.isOnEditOpened) this.onEditClose();
            });

            InputData.currentPageIdx = 16;
            if ( InputData.moveNext == 0 || InputData.moveNext == InputData.currentPageIdx ) this.timerService.isForwarding = false;
      }

      public ngOnInit() {

            super.forwardNext(this.data.eligibility.listedParentCount);
      }

      getParentNames() : void{
            let parentCounts = this.data.parents.length;

            if (this.isLegalCustody()) {
                  this.parentCertifyName = '<strong>' + this.getLegalCustodianName() + '</strong>'; 
            }else {
                  if(parentCounts == 1){
                        this.parentCertifyName = '<strong>' + this.data.parents[0].name.getFullName().trim() + '</strong>';
                  }else{
                        let certifyingParents = this.data.parents.filter((p) => p.isCertifyingParent == 'Y');

                        certifyingParents.forEach((p, index) => {
                              if(index == 0){
                                    this.parentCertifyName = '<strong>' + p.name.getFullName().trim() + '</strong>';
                              }
                              else if(index < parentCounts - 1 ){
                                    this.parentCertifyName  = this.parentCertifyName + ", " + '<strong>' + p.name.getFullName().trim()+ '</strong>';
                              }
                              else{
                                    this.parentCertifyName  = this.parentCertifyName + " and " + '<strong>' + p.name.getFullName().trim()+ '</strong>';
                              }
                        });
                  }
            }
      }

      getLegalCustodianName(){
            if ( this.eligibility.isOtherSingleName == Confirm.YES ) 
                  return this.eligibility.otherSingleName;
            else {
                  return this.eligibility.otherFirstName + ' ' + this.eligibility.otherLastName;
            }
      }

      getWeight(){
            if(this.data.aboutChild.grams){
                  this.childWeight =  this.data.aboutChild.grams.toString() + ' ' + 
                  this.translateService.instant('shared.weight.grams');

            } else if (this.data.aboutChild.pounds && this.data.aboutChild.ounces){
                  this.childWeight = this.data.aboutChild.pounds.toString() + ' ' + 
                  this.translateService.instant('shared.weight.lbs') + ' ' +
                  + this.data.aboutChild.ounces.toString() + ' ' +
                  this.translateService.instant('shared.weight.oz');
            }
      }

      getBirthOrder(){
            if(this.data.eligibility.birthType != "1") {
                  this.childBirthOrder = 'shared.birthOrder.' + this.data.aboutChild.birthOrder;
            }
      }

      getPlace(){
            if(this.data.aboutChild.birthPlaceType === BirthPlace.Hospital){
                  this.placeOfBirth = 'shared.birthPlace.HO'; 
            } else if(this.data.aboutChild.birthPlaceType === BirthPlace.BirthCenter)  {
                  this.placeOfBirth = 'shared.birthPlace.BC';
            } else if(this.data.aboutChild.birthPlaceType === BirthPlace.Home) {
                  this.placeOfBirth = 'shared.birthPlace.HM';
            } else if(this.data.aboutChild.birthPlaceType === BirthPlace.Other) {
                  this.placeOfBirth = 'shared.birthPlace.OT'; 
            }
      }


      getAttendant() {
            if(this.data.aboutChild.attendentType === 'P'){
                  this.attendantType = 'shared.attendant.P';
                  if(this.data.aboutChild.isDoctorSingleName != 'Y'){
                      this.attendantName = this.data.aboutChild.attendentFirstName + ' ' + this.data.aboutChild.attendentLastName;  
                  } else {
                      this.attendantName = this.data.aboutChild.attendentSingleName;
                  }
            } else if(this.data.aboutChild.attendentType === 'M'){
                  this.attendantType = 'shared.attendant.M';
                  if(this.data.aboutChild.isMidwifeSingleName != 'Y'){
                        this.attendantName = this.data.aboutChild.attendentFirstName + ' ' + this.data.aboutChild.attendentLastName;  
                  } else {
                        this.attendantName = this.data.aboutChild.attendentSingleName;
                  }
            } else if(this.data.aboutChild.attendentType === 'O'){
                  this.attendantType = 'shared.attendant.O';
                  if(this.data.aboutChild.isSomeoneElseSingleName != 'Y'){
                        this.attendantName = this.data.aboutChild.attendentFirstName + ' ' + this.data.aboutChild.attendentLastName;  
                  } else {
                        this.attendantName = this.data.aboutChild.attendentSingleName;
                  }
            }
      }

      getProvince(address : Address){
            if(address.chk_international == 'Y'){
                  return address.base.province;
            }else{
                  return this.items.provinceList.get(address.base.province);
            }
      }

      getParentPlaceOfBirth(baseAddress : BaseAddress){

            let placeOfBirth = '';

            if ( baseAddress ) {

                  if ( baseAddress.city ) {
                           placeOfBirth = baseAddress.city + ', ';      
                  }

                  if( baseAddress.country == Country.CANADA ) {
                      if ( baseAddress.province != Code.NotApplicable) {
                           placeOfBirth += this.items.provinceList.get(baseAddress.province) + ', ' 
                      }
                      placeOfBirth += this.items.countryList.get(baseAddress.country);   
                  }
                  else{
                      if ( baseAddress.country != Code.NotFound ) {
                           placeOfBirth += this.items.countryList.get(baseAddress.country);
                      }
                      else placeOfBirth +=  baseAddress.otherCountry;
                  }
            }

            return placeOfBirth;
      }

      getCountryName(addr: BaseAddress){
            if ( addr.country == Code.NotFound ) {
                 return addr.otherCountry;
            }
            return this.items.countryList.get(addr.country);
      }

      getBirthDate(birthday: string){
            if ( !birthday ) return null;
            
            let birthDateArray = birthday.split("-");
            let birthdate;
            this.translateService.get('shared.date.' + Number.parseInt(birthDateArray[1])).subscribe( (month) => {
                  birthdate = month + " " + birthDateArray[2] + ", " + birthDateArray[0];
            });
            
            return birthdate;
      }

      getParentAge(birthDate: string){
            return Util.age(birthDate, this.data.aboutChild.birthDay);
      }

      onNoticeClick(event){
            event.preventDefault();
            this.noticeOfCollectionBox.open();
            this.isOpened = true;
      }
      
      onNoticeClose(){
            this.eligibility.chkReadDisclosure = 'N';
            this.noticeOfCollectionBox.close();
            this.isOpened = false;
      }

      noticeOnAgree(){
            this.error_notice = null;
            this.eligibility.chkReadDisclosure = 'Y';
            this.noticeOfCollectionBox.close();
            this.isOpened = false;
      }

      public keyPress(event:any) {
            if ( event.keyCode == 13 ) {
                  this.onNoticeClose();
          }
      }

      PAGE: string;
      NON_BIRHT_PARENT_INDEX: string;

      onEdit(PAGE: string, pIndex: string){
            this.PAGE = PAGE;
            this.NON_BIRHT_PARENT_INDEX = pIndex;
            this.isOnEditOpened = true;
            this.editLightBox.open();
      }

      /**
      onEditContinue(){

            let url = "";
            if(this.PAGE == 'setup1') url = Path.Setup1;
            else 
            if(this.PAGE == 'aboutTheChild') url = Path.AboutTheChildMain;
            else 
            if(this.PAGE == 'aboutParent') url = Path.AboutTheParentsMain;
            else 
            if(this.PAGE == 'aboutParent_other')  {
                  let parentIndex = Number(this.NON_BIRHT_PARENT_INDEX) + 1;
                  if ( this.birthParent ) parentIndex++; 
                  url = Path.AboutTheParentsScreen + parentIndex;
            }
            else 
            if(this.PAGE == 'contactAndMailInfo') url = Path.ContactInfoAndMailingAddress;

            this.router.navigate(["/"+url]);  
            this.isOnEditOpened = false;
            this.onEditClose();
      }
      **/

      onEditContinue(){

            let goBackBy:number = 0;
            let target:number = 0;
            let totalParentCount = this.data.parents.length;

            if ( this.PAGE == 'setup1' ) {
                 goBackBy = -9 - totalParentCount;
                 target = 3;
            }
            else 
            if( this.PAGE == 'aboutTheChild' ) {
                goBackBy = -4 - totalParentCount;
                target = 8;
            }
            else 
            if( this.PAGE == 'aboutParent' ) {
                goBackBy = -2 - totalParentCount;
                target = 10;
            }
            else 
            if( this.PAGE == 'aboutParent_other' ) {
                 let parentIndex = Number(this.NON_BIRHT_PARENT_INDEX);
                 if ( this.birthParent ) parentIndex++; 
                 goBackBy = -1 - (totalParentCount-parentIndex);
                 target = 11 + parentIndex;
            }
            else 
            if(this.PAGE == 'contactAndMailInfo') {
                 goBackBy = -1;
                 target = 15;
            }
                    
            ///console.log("[edit]====>",target,goBackBy)
            this.timerService.isForwarding = true;
            InputData.moveNext = target;

            window.history.back();

            this.onEditClose();
      }


      onEditClose(){
            this.isOnEditOpened = false;
            this.editLightBox.close();
      }

      phoneNumberDisplay() : void {
            this.phoneNumber = this.data.contact.phoneNumber("-");
      }

      daytimePhoneDisplay() : void {
            this.daytimePhoneNumber = this.data.contact.dayTimeNumber("-");
      }

      isLegalCustody(){
            return this.eligibility.isCustodyOtherThanParent == Confirm.YES;
      }

      getDeliveryCode(deliveryMode: string): string{
            if(deliveryMode === 'PO Box'){
                  return 'PO';
            }else{
                  return deliveryMode;
            }
      }


      phoneExt(){
            if(Util.isEmpty(this.data.contact.phoneExt)){
                  return '';
            }
            return this.translateService.instant('final_review.contact_info.extension') + this.data.contact.phoneExt;
      }

      daytimePhoneExt(){
            if(Util.isEmpty(this.data.contact.daytimeExt)){
                  return '';
            }
            return this.translateService.instant('final_review.contact_info.extension') + this.data.contact.daytimeExt;
      }

      public onNextClick() : boolean {
             if ( super.onNextClick() ) {
                  this.progress.progressStatus[Progress.Review] = 2;    
             }
             else this.progress.progressStatus[Progress.Review] = 1;    

             return true;
      }

      public keyPressEnter(event:any, PAGE: string, pIndex: string) {
            if ( event.keyCode == 13 ) {
                  this.onEdit(PAGE, pIndex);        
            }
      }

      @HostListener('document:keydown.escape', ['$event'])
       public escape(){
             if(this.isOpened) {
                   this.onNoticeClose();
             }
             if(this.isOnEditOpened) {
                  this.onEditClose();
             }
      }
}
